import { t } from '@/plugins/i18n'

// 优先发货状态
const priorityShippingStatusDict = {
  0: t('否'),
  1: t('是')
}

// 发货状态
const deliveryStatusDict = {
  0: t('待处理'),
  1: t('部分发货'),
  2: t('可发货'),
  3: t('已发货'),
  4: t('待发货')
}

// 商品可优先发货
// row.priorityShippingStatus === 1 &&
export const canDeliveryPriority = (row: any) => row.deliveryStatus === 4
